import React, { Component } from 'react';
import { withStyles, withTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import clsx from 'clsx';

// ui/ux
import Badge from '@material-ui/core/Badge';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Typography from '@material-ui/core/Typography';

const styles = (theme) => ({
  indent: {
    marginLeft: theme.spacing(4)
  },
  enforceWrap: {
    '& > label': {
      maxWidth: '100%'
    },
    '& > .MuiTypography-body2': {
      wordBreak: 'break-word'
    }
  },
  divideFormRG: {
    flexDirection: 'row'
  },
  div: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }
});

class DivideForm extends Component {
  constructor(props) {
    super(props);
    console.log('DivideForm', JSON.stringify({ ...props, classes: null, theme: null, onComplete: null }));

    const formQuestions = props.formQuestions
      .filter((d) => ['SELECT_ONE'].includes(d.input_type))
      .flatMap((d) => {
        const o = [];
        for (let i = 0; i < d.labels.length; i++) {
          o.push({
            label: d.labels[i],
            name: d.names[i],
            opts: d.opts[i],
            input_type: d.input_type
          });
        }
        return o;
      });

    this.state = {
      formQuestions,
      formQuestionsSelected: [],
      mapping: {}
    };

    this.next = this.next.bind(this);
    this.onRadioChange = this.onRadioChange.bind(this);
    this.renderButtons = this.renderButtons.bind(this);
    this.onCheckboxChange = this.onCheckboxChange.bind(this);
  }
  next() {
    const { mapping } = this.state;
    const { onComplete } = this.props;

    onComplete(mapping);
  }
  renderButtons(formValid) {
    const { formQuestionsSelected } = this.state;
    const { selectedTopics } = this.props;
    return (
      <Grid container justifyContent="flex-end" spacing={2}>
        <Grid item>
          <Button disabled={!formValid} variant="outlined" color="secondary" onClick={this.next}>
            {selectedTopics.length === 1 && formQuestionsSelected.length === 0 ? 'Skip' : 'Next'}
          </Button>
        </Grid>
      </Grid>
    );
  }

  formValid() {
    const { formQuestionsSelected, mapping } = this.state;
    const { selectedTopics } = this.props;
    if (!selectedTopics || !formQuestionsSelected) {
      return false;
    }
    if (selectedTopics.length === 1 && formQuestionsSelected.length === 0) {
      return true;
    }

    if (formQuestionsSelected.length === 0) {
      return false;
    }

    return Object.keys(mapping)
      .map((d) => this.questionHasValidMapping(d))
      .reduce((a, b) => a && b, true);
  }

  questionHasValidMapping(questionName) {
    const { mapping } = this.state;
    const answers = mapping[questionName];
    if (!answers) return false;
    return Object.values(answers).filter((d) => d !== 'na').length > 0;
  }

  onCheckboxChange(e, formQuestion) {
    const { checked } = e.target;
    const { formQuestionsSelected, mapping } = this.state;

    const idx = formQuestionsSelected.indexOf(formQuestion);

    if (checked && idx === -1) {
      return this.setState({
        formQuestionsSelected: [...formQuestionsSelected, formQuestion],
        mapping: {
          ...mapping,
          [formQuestion.name]: {}
        }
      });
    }

    if (!checked && idx !== -1) {
      const newMapping = {
        ...mapping
      };
      delete newMapping[formQuestion.name];
      return this.setState({
        formQuestionsSelected: [...formQuestionsSelected.slice(0, idx), ...formQuestionsSelected.slice(idx + 1)],
        mapping: newMapping
      });
    }
  }

  onRadioChange(e, formQuestion, formAnswer) {
    const { value } = e.target;
    const { mapping } = this.state;
    const existingMap = mapping[formQuestion.name] || {};

    this.setState({
      mapping: {
        ...mapping,
        [formQuestion.name]: {
          ...existingMap,
          [formAnswer.value]: value
        }
      }
    });
  }

  getRadioState(formQuestion, formAnswer) {
    const { mapping } = this.state;
    if (mapping[formQuestion.name] && mapping[formQuestion.name][formAnswer.value]) {
      return mapping[formQuestion.name][formAnswer.value];
    }

    return 'na';
  }

  render() {
    const { classes, selectedTopics } = this.props;
    const { formQuestions, formQuestionsSelected } = this.state;
    const formValid = this.formValid();
    return (
      <React.Fragment>
        <Typography>{'Optionally, do you want to divert data from this form in different topics based on an answer to a question?'}</Typography>
        {this.renderButtons(formValid)}
        <Grid container>
          <Grid item xs={6}>
            <Typography variant="h5">Select questions that could determine the topic</Typography>

            <FormGroup row={false} className={clsx(classes.indent, classes.enforceWrap)}>
              {formQuestions.map((d, i) => (
                <React.Fragment key={i}>
                  <Badge
                    badgeContent={formQuestionsSelected.indexOf(d) === -1 || this.questionHasValidMapping(d.name) ? 0 : 1}
                    color="error"
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'left'
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formQuestionsSelected.indexOf(d) > -1}
                          onChange={(e) => {
                            this.onCheckboxChange(e, d);
                          }}
                        />
                      }
                      label={d.label}
                    />
                  </Badge>
                  <Box className={classes.indent}>
                    {d.opts.map((d1) => (
                      // {
                      //   "label": "Yes",
                      //   "value": "yes",
                      //   "image_url": null
                      // },
                      <React.Fragment key={d1.label}>
                        <Typography variant="body2">{`${d1.label}(${d1.value})`}</Typography>
                        {formQuestionsSelected.indexOf(d) > -1 ? (
                          <Box className={classes.indent}>
                            <RadioGroup
                              name={`rg-topics-${d1.value}`}
                              value={this.getRadioState(d, d1)}
                              onChange={(e) => {
                                this.onRadioChange(e, d, d1);
                              }}
                              className={classes.divideFormRG}
                            >
                              <FormControlLabel value="na" control={<Radio />} label="n/a" />
                              {selectedTopics.map((d1) => (
                                <FormControlLabel key={d1} value={d1} control={<Radio />} label={d1} />
                              ))}
                            </RadioGroup>
                          </Box>
                        ) : null}
                      </React.Fragment>
                    ))}
                  </Box>
                </React.Fragment>
              ))}
            </FormGroup>
          </Grid>
          <Grid item xs={6}></Grid>
        </Grid>
        {this.renderButtons(formValid)}
      </React.Fragment>
    );
  }
}

DivideForm.propTypes = {
  theme: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,

  formQuestions: PropTypes.array.isRequired,
  selectedForm: PropTypes.object.isRequired,
  topic: PropTypes.string.isRequired,
  selectedTopics: PropTypes.array.isRequired,
  onComplete: PropTypes.func.isRequired
};

DivideForm.defaultProps = {};

export default withTheme(withStyles(styles)(DivideForm));
